var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.87926 2.87904C4.08841 1.66988 6.05417 1.66988 7.26332 2.87904L10.0917 5.70746L11.4352 4.36396L8.60682 1.53553C6.65521 -0.416081 3.48737 -0.416081 1.53576 1.53553C-0.41586 3.48715 -0.415859 6.65499 1.53576 8.6066L4.36418 11.435L5.70768 10.0915L2.87926 7.2631C1.67011 6.05395 1.67011 4.08819 2.87926 2.87904ZM5.07129 6.48528L10.7281 12.1421L12.1424 10.7279L6.4855 5.07107L5.07129 6.48528ZM15.6779 8.6066L12.8495 5.77817L11.506 7.12168L14.3344 9.9501C15.5435 11.1593 15.5435 13.125 14.3344 14.3342C13.1252 15.5433 11.1595 15.5433 9.95033 14.3342L7.1219 11.5057L5.7784 12.8492L8.60682 15.6777C10.5584 17.6293 13.7263 17.6293 15.6779 15.6777C17.6295 13.7261 17.6295 10.5582 15.6779 8.6066Z",
    fill: "#81FEB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.4ddc68bd3699599f593e2289d58ad4c3.svg";
export { ForwardRef as ReactComponent };